import {connect} from 'react-redux';
import Tutorial from '../components/Tutorial';
import {getVideoTutorialsLinks} from "../selectors";

export default connect(
    (state) => ({
        localConfigurator: state.configurator.localConfigurator,
        videoTutorialLinks: getVideoTutorialsLinks(state)
    }), null
)(Tutorial);